import { render, staticRenderFns } from "./AddBillingRatePeriod.vue?vue&type=template&id=8be1546e&"
import script from "./AddBillingRatePeriod.vue?vue&type=script&lang=js&"
export * from "./AddBillingRatePeriod.vue?vue&type=script&lang=js&"
import style0 from "./AddBillingRatePeriod.vue?vue&type=style&index=0&id=8be1546e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports